/* BMN site-wide logo preview.
 * The customer uploads their logo once. It is kept in their browser and:
 *  - every product card swaps to the flat front photo with the logo on the left chest,
 *    plus a "+ logo from £x each" line under the price;
 *  - product pages (enriched builder) start with the logo on the left chest; tapping
 *    another position puts the logo there too;
 *  - on add to cart the original logo file is attached to each Branding line it is used on.
 */
(function () {
  'use strict';
  if (window.__bmnSiteLogo) return;
  window.__bmnSiteLogo = true;

  var CFG = window.BMNSiteLogo || {};
  var KEY = 'bmn_site_logo_v1';
  var KEY_ORIG = 'bmn_site_logo_orig_v1';
  var KEY_HIDE = 'bmn_site_logo_hide_v1';
  var KEY_FRONT = 'bmn_site_logo_front_v2';
  var FROM_EX = parseFloat(CFG.fromEx) || 2.95;
  var POS_LABEL = { lc: 'Left chest', rc: 'Right chest', cc: 'Centre chest', ff: 'Full front', np: 'Nape / neck', ub: 'Upper back', fb: 'Full back', ls: 'Left sleeve', rs: 'Right sleeve' };
  var ALLOW = /polo|t-?shirt|tee|shirt|sweat|hood|jacket|fleece|gilet|vest|bodywarmer|softshell|coat|jumper|knit|blouse|tabard|tunic|overall|coverall|parka|waistcoat|top|smock|jersey|scrub/i;
  var DENY = /cap|hat|beanie|headwear|bag|tote|rucksack|backpack|sock|glove|boot|shoe|footwear|trouser|shorts|legging|jogger|skirt|umbrella|mug|bottle|towel|blanket|accessor|branding|setup|lanyard|keyring|pen\b|apron|gift/i;

  /* ---------- storage (every access guarded) ---------- */
  var mem = {};
  function sGet(k) { try { var v = localStorage.getItem(k); if (v != null) return v; } catch (e) {} return mem[k] == null ? null : mem[k]; }
  function sSet(k, v) { mem[k] = v; try { localStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function sDel(k) { delete mem[k]; try { localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function getLogo() { var r = sGet(KEY); if (!r) return null; try { return JSON.parse(r); } catch (e) { return null; } }
  function isHidden() { return sGet(KEY_HIDE) === '1'; }
  function active() { return !!getLogo() && !isHidden(); }

  function money(n) { return '£' + n.toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function say(t) {
    var el = document.createElement('div'); el.className = 'bmn-sl-msg'; el.textContent = t; el.setAttribute('role', 'status');
    document.body.appendChild(el); setTimeout(function () { el.remove(); }, 3800);
  }

  /* ---------- logo processing ---------- */
  function loadImg(src) {
    return new Promise(function (res, rej) {
      var i = new Image(); i.crossOrigin = 'anonymous'; i.decoding = 'async';
      i.onload = function () { res(i); }; i.onerror = rej; i.src = src;
    });
  }
  function readAsDataURL(file) {
    return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(file); });
  }
  function dataToFile(dataURL, name) {
    var parts = dataURL.split(','), mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/png';
    var bin = atob(parts[1]), n = bin.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bin.charCodeAt(n);
    return new File([u8], name, { type: mime });
  }
  /* Removes a plain background (flood fill from the edges) and trims the empty margin. */
  function processLogo(img) {
    var max = 700, w = img.naturalWidth || img.width || 600, h = img.naturalHeight || img.height || 600;
    var k = Math.min(1, max / Math.max(w, h)); w = Math.max(1, Math.round(w * k)); h = Math.max(1, Math.round(h * k));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h), p = d.data, i, j;
    var transparentEdge = false;
    for (i = 0; i < w && !transparentEdge; i += 3) { if (p[(i) * 4 + 3] < 200 || p[((h - 1) * w + i) * 4 + 3] < 200) transparentEdge = true; }
    for (j = 0; j < h && !transparentEdge; j += 3) { if (p[(j * w) * 4 + 3] < 200 || p[(j * w + w - 1) * 4 + 3] < 200) transparentEdge = true; }
    var removed = false;
    if (!transparentEdge) {
      var cs = [0, w - 1, (h - 1) * w, h * w - 1].map(function (q) { return [p[q * 4], p[q * 4 + 1], p[q * 4 + 2]]; });
      var bg = [0, 1, 2].map(function (ch) { return (cs[0][ch] + cs[1][ch] + cs[2][ch] + cs[3][ch]) / 4; });
      var uniform = cs.every(function (cc) { return Math.abs(cc[0] - bg[0]) + Math.abs(cc[1] - bg[1]) + Math.abs(cc[2] - bg[2]) < 60; });
      if (uniform) {
        var tol = 70, seen = new Uint8Array(w * h), stack = [];
        for (i = 0; i < w; i++) { stack.push(i, (h - 1) * w + i); }
        for (j = 0; j < h; j++) { stack.push(j * w, j * w + w - 1); }
        while (stack.length) {
          var q = stack.pop(); if (seen[q]) continue; seen[q] = 1;
          var o = q * 4, df = Math.abs(p[o] - bg[0]) + Math.abs(p[o + 1] - bg[1]) + Math.abs(p[o + 2] - bg[2]);
          if (df > tol) continue;
          p[o + 3] = df < tol * 0.6 ? 0 : Math.round(255 * (df - tol * 0.6) / (tol * 0.4));
          var qx = q % w, qy = (q - qx) / w;
          if (qx > 0) stack.push(q - 1); if (qx < w - 1) stack.push(q + 1);
          if (qy > 0) stack.push(q - w); if (qy < h - 1) stack.push(q + w);
        }
        x.putImageData(d, 0, 0); removed = true;
      }
    }
    // trim
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (j = 0; j < h; j++) for (i = 0; i < w; i++) {
      if (p[(j * w + i) * 4 + 3] > 24) { if (i < minX) minX = i; if (i > maxX) maxX = i; if (j < minY) minY = j; if (j > maxY) maxY = j; }
    }
    if (maxX < 0) return null;
    var tw = maxX - minX + 1, th = maxY - minY + 1, t = document.createElement('canvas'); t.width = tw; t.height = th;
    t.getContext('2d').drawImage(c, minX, minY, tw, th, 0, 0, tw, th);
    return { src: t.toDataURL('image/png'), w: tw, h: th, removed: removed };
  }

  function saveFromFile(file) {
    if (!file) return Promise.resolve(false);
    if (!/^image\/(png|jpe?g|gif|webp|svg\+xml)$/i.test(file.type)) {
      say('Use a PNG, JPG or SVG to preview. You can still send any file with your order.');
      return Promise.resolve(false);
    }
    if (file.size > 15 * 1024 * 1024) { say('That file is over 15MB. Try a smaller version.'); return Promise.resolve(false); }
    return readAsDataURL(file).then(function (orig) {
      return loadImg(orig).then(function (img) {
        var pr = processLogo(img);
        if (!pr) { say('We could not read that logo. Try a PNG or JPG.'); return false; }
        var rec = { src: pr.src, w: pr.w, h: pr.h, name: file.name || 'logo.png', type: file.type, removed: pr.removed, t: Date.now() };
        if (!sSet(KEY, JSON.stringify(rec))) { mem[KEY] = JSON.stringify(rec); }
        if (orig.length < 3.2e6) { if (!sSet(KEY_ORIG, orig)) sDel(KEY_ORIG); } else sDel(KEY_ORIG);
        sDel(KEY_HIDE);
        refreshAll();
        say('Your logo is on. Browse any garment to see it.');
        return true;
      });
    }).catch(function () { say('We could not read that logo. Try a PNG or JPG.'); return false; });
  }
  function clearLogo() { sDel(KEY); sDel(KEY_ORIG); sDel(KEY_HIDE); refreshAll(); }

  var picker = null;
  function pick() {
    if (!picker) {
      picker = document.createElement('input'); picker.type = 'file'; picker.accept = 'image/png,image/jpeg,image/svg+xml,image/webp,image/gif'; picker.hidden = true;
      picker.addEventListener('change', function () { var f = picker.files && picker.files[0]; picker.value = ''; saveFromFile(f); });
      document.body.appendChild(picker);
    }
    picker.click();
  }

  /* ---------- floating button ---------- */
  var fab;
  var UP = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 16V4M6 10l6-6 6 6"/><path d="M4 20h16"/></svg>';
  function renderFab() {
    if (CFG.fab === false) return;
    if (!fab) {
      fab = document.createElement('div'); fab.className = 'bmn-sl-fab';
      document.body.appendChild(fab);
      fab.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sl]'); if (!b) return;
        var a = b.getAttribute('data-sl'), menu = fab.querySelector('.bmn-sl-fab__menu');
        if (a === 'toggle') { if (getLogo() || (menu && window.BMNFindLogo)) { menu.hidden = !menu.hidden; b.setAttribute('aria-expanded', String(!menu.hidden)); } else pick(); }
        else if (a === 'web') { menu.hidden = true; if (window.BMNFindLogo) window.BMNFindLogo.open(); }
        else if (a === 'change') { menu.hidden = true; pick(); }
        else if (a === 'hide') { menu.hidden = true; if (isHidden()) sDel(KEY_HIDE); else sSet(KEY_HIDE, '1'); refreshAll(); }
        else if (a === 'remove') { menu.hidden = true; clearLogo(); say('Logo removed.'); }
      });
      document.addEventListener('click', function (e) { if (fab && !fab.contains(e.target)) { var m = fab.querySelector('.bmn-sl-fab__menu'); if (m) m.hidden = true; } });
    }
    var L = getLogo();
    if (!L) {
      fab.innerHTML = (window.BMNFindLogo ? '<div class="bmn-sl-fab__menu" hidden><p>See your logo on every garment. Free, nothing is ordered.</p><button type="button" data-sl="web">Find it from my website</button><button type="button" data-sl="change">Upload a logo file</button></div>' : '') +
        '<button type="button" class="bmn-sl-fab__btn" data-sl="toggle" aria-expanded="false" aria-label="Preview your logo on our garments">' + UP + '<span class="bmn-sl-fab__label">Preview your logo</span></button>';
    } else {
      fab.innerHTML = '<div class="bmn-sl-fab__menu" hidden><img alt="Your logo" src="' + L.src + '"><p>' + (isHidden() ? 'Your logo is saved but hidden.' : 'Your logo shows on every garment and product page. It stays in this browser only.') + '</p>' +
        '<button type="button" data-sl="change">Change logo</button>' + (window.BMNFindLogo ? '<button type="button" data-sl="web">Find it from my website</button>' : '') +
        '<button type="button" data-sl="hide">' + (isHidden() ? 'Show it on products' : 'Hide it for now') + '</button>' +
        '<button type="button" data-sl="remove">Remove logo</button></div>' +
        '<button type="button" class="bmn-sl-fab__btn" data-sl="toggle" aria-expanded="false" aria-label="Your logo options"><span class="bmn-sl-fab__thumb" style="background-image:url(' + L.src + ')"></span><span class="bmn-sl-fab__label">Your logo</span></button>';
    }
  }

  /* ---------- collection / search banner ---------- */
  function renderBanner() {
    var grid = document.getElementById('product-grid') || document.querySelector('.collection .product-grid, ul.product-grid');
    var old = document.querySelector('.bmn-sl-banner');
    if (!grid || CFG.cards === false) { if (old) old.remove(); return; }
    var b = old || document.createElement('div');
    b.className = 'bmn-sl-banner';
    var L = getLogo();
    if (!L) {
      b.innerHTML = '<div class="bmn-sl-banner__text"><strong>See your logo on every garment</strong>Upload it once and every product shows it on the left chest. Free, and nothing is ordered.</div>' +
        '<div class="bmn-sl-banner__btns"><button type="button" data-slb="up">Upload your logo</button>' + (window.BMNFindLogo ? '<button type="button" class="bmn-sl-ghost" data-slb="web">Find it from my website</button>' : '') + '</div>';
    } else if (isHidden()) {
      b.innerHTML = '<span class="bmn-sl-banner__thumb" style="background-image:url(' + L.src + ')"></span><div class="bmn-sl-banner__text"><strong>Your logo is hidden</strong>Switch it back on to see it on every garment.</div>' +
        '<div class="bmn-sl-banner__btns"><button type="button" data-slb="show">Show my logo</button><button type="button" class="bmn-sl-ghost" data-slb="remove">Remove</button></div>';
    } else {
      b.innerHTML = '<span class="bmn-sl-banner__thumb" style="background-image:url(' + L.src + ')"></span><div class="bmn-sl-banner__text"><strong>Showing your logo on the left chest</strong>Card prices are the garment. Your logo is from <span class="vat-ex">' + money(FROM_EX) + '</span><span class="vat-inc">' + money(FROM_EX * 1.2) + '</span> each, priced exactly on the product page, where you can move it or add more positions.</div>' +
        '<div class="bmn-sl-banner__btns"><button type="button" data-slb="up">Change logo</button><button type="button" class="bmn-sl-ghost" data-slb="hide">Hide</button></div>';
    }
    if (!old) {
      b.addEventListener('click', function (e) {
        var t = e.target.closest('[data-slb]'); if (!t) return;
        var a = t.getAttribute('data-slb');
        if (a === 'up') pick(); else if (a === 'web') { if (window.BMNFindLogo) window.BMNFindLogo.open(); } else if (a === 'hide') { sSet(KEY_HIDE, '1'); refreshAll(); } else if (a === 'show') { sDel(KEY_HIDE); refreshAll(); } else if (a === 'remove') clearLogo();
      });
      grid.parentNode.insertBefore(b, grid);
    }
  }

  /* ---------- product cards ---------- */
  var frontCache = null;
  function fc() { if (!frontCache) { try { frontCache = JSON.parse(ssGet(KEY_FRONT) || '{}'); } catch (e) { frontCache = {}; } } return frontCache; }
  function fcSave() { ssSet(KEY_FRONT, JSON.stringify(frontCache || {})); }
  var inflight = {};
  function frontFor(handle) {
    var c = fc(); if (c[handle] !== undefined) return Promise.resolve(c[handle]);
    if (inflight[handle]) return inflight[handle];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    inflight[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=bmnfront', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { var j = null; try { j = t ? JSON.parse(t.trim()) : null; } catch (e) { j = null; } c[handle] = j; fcSave(); return j; })
      .catch(function () { return null; });
    return inflight[handle];
  }
  function abs(u) { return u && u.indexOf('//') === 0 ? location.protocol + u : u; }

  /* Finds the left chest on a flat front photo: plain background, garment bounding box,
     torso width measured below the sleeves. Returns null when the photo is not a flat shot. */
  var placeCache = {};
  function chestBox(img, hood) {
    var key = img.src + (hood ? '#h' : ''); if (placeCache[key] !== undefined) return placeCache[key];
    var W = 100, H = Math.max(40, Math.round(100 * img.naturalHeight / img.naturalWidth));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, W, H);
    var p; try { p = x.getImageData(0, 0, W, H).data; } catch (e) { return (placeCache[key] = null); }
    function px(i, j) { var o = (j * W + i) * 4; return [p[o], p[o + 1], p[o + 2]]; }
    var cs = [px(1, 1), px(W - 2, 1), px(1, H - 2), px(W - 2, H - 2), px(1, Math.round(H / 2)), px(W - 2, Math.round(H / 2))];
    var bg = [0, 1, 2].map(function (k) { return (cs[0][k] + cs[1][k] + cs[2][k] + cs[3][k]) / 4; });
    var flat = cs.every(function (v) { return Math.abs(v[0] - bg[0]) + Math.abs(v[1] - bg[1]) + Math.abs(v[2] - bg[2]) < 36; }) && (bg[0] + bg[1] + bg[2]) > 705; // flat supplier shots sit on pure white; studio and model photos do not
    if (!flat) return (placeCache[key] = null);
    function on(i, j) { var v = px(i, j); return Math.abs(v[0] - bg[0]) + Math.abs(v[1] - bg[1]) + Math.abs(v[2] - bg[2]) > 45; }
    var top = -1, bot = -1, l = W, r = -1, i, j;
    for (j = 0; j < H; j++) for (i = 0; i < W; i++) if (on(i, j)) { if (top < 0) top = j; bot = j; if (i < l) l = i; if (i > r) r = i; }
    var res = { flat: true };
    if (top >= 0 && (bot - top) > H * 0.45 && (r - l) > W * 0.4) {
      var h = bot - top, ry = Math.round(top + 0.62 * h), tl = -1, tr = -1;
      for (i = 0; i < W; i++) if (on(i, ry)) { if (tl < 0) tl = i; tr = i; }
      if (tl >= 0 && (tr - tl) > W * 0.28) {
        var tw = tr - tl;
        // a hood shows as a narrow top: 15% down the garment it is still much narrower than the torso
        if (!hood) { var hy = Math.round(top + 0.15 * h), hl = -1, hr = -1; for (i = 0; i < W; i++) if (on(i, hy)) { if (hl < 0) hl = i; hr = i; } if (hl >= 0 && (hr - hl) < 0.9 * tw) hood = true; }
        res.cx = (tl + (hood ? 0.71 : 0.70) * tw) / W; res.cy = (top + (hood ? 0.37 : 0.27) * h) / H; res.bw = 0.27 * tw / W; res.bh = 0.21 * tw / W * (W / H);
      }
    }
    if (res.cx == null) { res.cx = 0.62; res.cy = 0.33; res.bw = 0.15; res.bh = 0.12 * (W / H); } // white garment on white: standard framing
    return (placeCache[key] = res);
  }

  var logoImgP = null, logoImgSrc = '';
  function logoImg() {
    var L = getLogo(); if (!L) return Promise.reject();
    if (!logoImgP || logoImgSrc !== L.src) { logoImgSrc = L.src; logoImgP = loadImg(L.src); }
    return logoImgP;
  }

  /* Visualiser v1: garments with a print-area template (assets/bmn-visualiser.js) are placed from
     the template, with the embroidery or print look for that garment. The top 20 are calibrated. */
  function visOK(h, t, title) {
    var V = window.BMNVis; if (!V) return false;
    var inf = V.info(h, t, title); return !!(inf && inf.calibrated && inf.positions.length);
  }
  function compose(front, logo, hood, j, title) {
    var V = window.BMNVis;
    if (V && j) {
      var inf = V.info(j.h, j.t, title);
      if (inf && inf.positions.length) {
        var pos = inf.positions.indexOf('lc') >= 0 ? 'lc' : inf.positions[0];
        var cv = V.composite(front, j.h, j.t, title, [{ pos: pos, logo: logo, method: inf.def === 'dtf' ? 'dtf' : 'emb' }], 700);
        if (cv) return new Promise(function (res) { cv.toBlob(function (b) { res(b ? URL.createObjectURL(b) : null); }, 'image/jpeg', 0.88); });
        if (inf.calibrated) return null;
      } else if (inf && inf.calibrated) return null;   // caps wait for a forward-facing base photo
    }
    var box = chestBox(front, hood); if (!box) return null;
    var cw = Math.min(700, front.naturalWidth), ch = Math.round(cw * front.naturalHeight / front.naturalWidth);
    var c = document.createElement('canvas'); c.width = cw; c.height = ch;
    var x = c.getContext('2d'); x.drawImage(front, 0, 0, cw, ch);
    var bw = box.bw * cw, bh = box.bh * ch, k = Math.min(bw / logo.naturalWidth, bh / logo.naturalHeight);
    var lw = logo.naturalWidth * k, lh = logo.naturalHeight * k;
    x.globalAlpha = 0.97; x.drawImage(logo, box.cx * cw - lw / 2, box.cy * ch - lh / 2, lw, lh);
    return new Promise(function (res) { c.toBlob(function (b) { res(b ? URL.createObjectURL(b) : null); }, 'image/jpeg', 0.88); });
  }

  function cardHandle(card) {
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null;
  }
  function cardTitle(card) { var h = card.querySelector('.card__heading'); return h ? h.textContent.trim() : ''; }

  function restoreCard(card) {
    var img = card.querySelector('.card__media img[data-bmn-sl-src]');
    if (img) {
      img.src = img.getAttribute('data-bmn-sl-src');
      if (img.getAttribute('data-bmn-sl-srcset')) img.setAttribute('srcset', img.getAttribute('data-bmn-sl-srcset'));
      img.removeAttribute('data-bmn-sl-src'); img.removeAttribute('data-bmn-sl-srcset');
    }
    var f = card.querySelector('.bmn-sl-from'); if (f) f.remove();
    var t = card.querySelector('.bmn-sl-tag'); if (t) t.remove();
    card.removeAttribute('data-bmn-sl');
  }

  var queue = [], running = 0, MAXRUN = 4;
  function pump() {
    while (running < MAXRUN && queue.length) {
      var card = queue.shift(); running++;
      doCard(card).catch(function () {}).then(function () { running--; pump(); });
    }
  }
  function doCard(card) {
    var stamp = String(getLogo() && getLogo().t);
    if (card.getAttribute('data-bmn-sl') === stamp) return Promise.resolve();
    var handle = cardHandle(card), title = cardTitle(card);
    var img = card.querySelector('.card__media img');
    if (!handle || !img || /^bmn-/.test(handle) || (DENY.test(title) && !visOK(handle, '', title))) { card.setAttribute('data-bmn-sl', stamp); return Promise.resolve(); }
    return frontFor(handle).then(function (j) {
      if (!active()) return;
      var type = (j && j.t) || '';
      if (!j || !j.f || j.p || ((DENY.test(type) || !(ALLOW.test(type) || ALLOW.test(title))) && !visOK(j.h, type, title))) { card.setAttribute('data-bmn-sl', stamp); return; }
      return Promise.all([loadImg(abs(j.f)), logoImg()]).then(function (r) {
        return compose(r[0], r[1], /hood/i.test(type + ' ' + title), j, title);
      }).then(function (url) {
        card.setAttribute('data-bmn-sl', stamp);
        if (!url || !active()) return;
        if (!img.hasAttribute('data-bmn-sl-src')) {
          img.setAttribute('data-bmn-sl-src', img.getAttribute('src') || '');
          img.setAttribute('data-bmn-sl-srcset', img.getAttribute('srcset') || '');
        }
        img.removeAttribute('srcset'); img.src = url;
        var media = img.closest('.card__media');
        if (media && !media.querySelector('.bmn-sl-tag')) { var tag = document.createElement('span'); tag.className = 'bmn-sl-tag'; tag.textContent = 'Your logo'; media.appendChild(tag); }
        var price = card.querySelector('.card-information .price, .price');
        if (price && !card.querySelector('.bmn-sl-from')) {
          var f = document.createElement('div'); f.className = 'bmn-sl-from';
          f.innerHTML = (/^bundle-/.test(handle) || /bundle/i.test(type)) ? 'Logo included in the bundle price' : '+ logo from <span class="vat-ex">' + money(FROM_EX) + '</span><span class="vat-inc">' + money(FROM_EX * 1.2) + '</span> each';
          price.parentNode.insertBefore(f, price.nextSibling);
        }
      });
    });
  }

  var io = null;
  function cards() { return Array.prototype.slice.call(document.querySelectorAll('.card-wrapper')).filter(function (c) { return !c.closest('.bmn-epdp, .bmn-bundle, [data-bmn-sl-skip]'); }); }
  function scanCards() {
    var list = cards();
    if (!active() || CFG.cards === false) { list.forEach(restoreCard); return; }
    var stamp = String(getLogo().t);
    if (!io && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); queue.push(e.target); } }); pump();
      }, { rootMargin: '600px 0px' });
    }
    list.forEach(function (c) {
      if (c.getAttribute('data-bmn-sl') === stamp) return;
      if (c.getAttribute('data-bmn-sl')) restoreCard(c);
      if (io) io.observe(c); else queue.push(c);
    });
    pump();
  }

  /* ---------- product page (enriched builder) ---------- */
  var attach = {};           // position id -> File to attach to that Branding line
  var autoDone = false, pdpReady = false, own = {};
  function pdpRoot() { return document.querySelector('.bmn-epdp'); }
  function logoFile() {
    var L = getLogo(); if (!L) return null;
    var orig = sGet(KEY_ORIG);
    return { preview: dataToFile(L.src, (L.name || 'logo').replace(/\.[a-z0-9]+$/i, '') + '.png'), original: orig ? dataToFile(orig, L.name || 'logo.png') : null };
  }
  function setFile(input, file) {
    try { var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; } catch (e) { return false; }
    input.dispatchEvent(new Event('change', { bubbles: true })); return true;
  }
  function applyToPos(id) {
    var root = pdpRoot(); if (!root || !active()) return;
    var sel = root.querySelector('select.bmn-epdp__source[data-pos="' + id + '"]');
    if (!sel || sel.value !== 'later') return;
    sel.value = 'upload'; sel.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () {
      var inp = root.querySelector('input.bmn-epdp__file[data-pos="' + id + '"]'); var lf = logoFile();
      if (!inp || !lf) return;
      if (setFile(inp, lf.preview)) attach[id] = lf.original || lf.preview;
    }, 0);
  }
  function pdpNote(root, label) {
    var box = root.querySelector('.bmn-epdp__positions'); if (!box || root.querySelector('.bmn-sl-note')) return;
    var n = document.createElement('p'); n.className = 'bmn-sl-note';
    var lab = label || 'Left chest', many = Array.prototype.filter.call(root.querySelectorAll('.bmn-epdp__pos'), function (b) { return !b.disabled && b.style.display !== 'none'; }).length > 1;
    n.innerHTML = '<strong>Your logo is on the ' + esc(lab.toLowerCase()) + '.</strong> ' + (many ? 'Tap another position to add it there too, or tap ' + esc(lab) + ' to take it off.' : 'Tap ' + esc(lab) + ' to take it off.') + ' The price below includes it.';
    box.parentNode.insertBefore(n, box);
  }
  function initPdp() {
    var root = pdpRoot(); if (!root || CFG.pdp === false) return;
    // the customer picking a file themselves: remember it for the order
    root.addEventListener('change', function (e) {
      var f = e.target.closest && e.target.closest('input.bmn-epdp__file');
      if (f && e.isTrusted && f.files && f.files[0]) {
        attach[f.getAttribute('data-pos')] = f.files[0];
        if (getLogo()) own[f.getAttribute('data-pos')] = true; // a different logo on this position: keep it when the main logo changes
        if (!getLogo()) saveFromFile(f.files[0]); // upload once: remember it for the rest of the site
      }
    }, true);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.bmn-epdp__pos'); if (!b) return;
      var id = b.getAttribute('data-id');
      setTimeout(function () { if (b.classList.contains('is-on')) applyToPos(id); else { delete attach[id]; delete own[id]; } }, 30);
    });
    var tries = 0; pdpReady = false;
    (function wait() {
      var lc = root.querySelector('.bmn-epdp__pos[data-id="lc"]');
      if (!lc && tries++ < 40) return setTimeout(wait, 150);
      setTimeout(function () { pdpReady = true; autoStart(); }, 250);
    })();
  }
  function autoStart() {
    var root = pdpRoot(); if (!root || autoDone || !active()) return;
    if (root.querySelector('.bmn-epdp__pos.is-on')) { autoDone = true; return; }
    var b = root.querySelector('.bmn-epdp__pos[data-id="lc"]');
    if (!b || b.disabled || b.offsetParent === null) b = root.querySelector('.bmn-epdp__pos[data-id="cc"]');
    if (!b || b.disabled) return;
    autoDone = true;
    var id = b.getAttribute('data-id');
    b.click();
    setTimeout(function () { applyToPos(id); }, 60);
    pdpNote(root, (b.textContent || '').trim());
  }

  /* ---------- bundle page: prefill the bundle logo upload ---------- */
  var bundleDone = false;
  function initBundle() {
    var inp = document.querySelector('input.bmn-bundle__file'); if (!inp) return;
    inp.addEventListener('change', function (e) {
      if (e.isTrusted && inp.files && inp.files[0] && !getLogo()) saveFromFile(inp.files[0]);
    });
    prefillBundle();
  }
  function prefillBundleForce() { var inp = document.querySelector('input.bmn-bundle__file'); var lf = logoFile(); if (inp && lf) { bundleDone = true; setFile(inp, lf.original || lf.preview); } }
  function prefillBundle() {
    var inp = document.querySelector('input.bmn-bundle__file');
    if (!inp || bundleDone || !active() || CFG.pdp === false) return;
    if (inp.files && inp.files.length) { bundleDone = true; return; }
    var lf = logoFile(); if (!lf) return;
    bundleDone = true;
    setTimeout(function () { if (!(inp.files && inp.files.length)) setFile(inp, lf.original || lf.preview); }, 400);
  }

  /* ---------- attach the logo file to the order ---------- */
  var labelToId = {}; Object.keys(POS_LABEL).forEach(function (k) { labelToId[POS_LABEL[k]] = k; });
  labelToId['Front'] = 'cc'; labelToId['Front patch'] = 'cc';   // headwear labels from the visualiser templates
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var pr = window.__bmnProof && (Date.now() - window.__bmnProof.at < 60000) ? window.__bmnProof : null;
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string' && (Object.keys(attach).length || pr)) {
        var body = JSON.parse(init.body);
        if (body && Array.isArray(body.items)) {
          var withFile = [], rest = [], proofDone = !pr;
          body.items.forEach(function (it) {
            var P = it.properties || {}, pos = labelToId[P.Position], files = [];
            if (pos && attach[pos] && !P.Text && !P.Names) files.push(['Logo file', attach[pos]]);   // text lines carry no logo file
            if (!proofDone && P.Position && /^(Print|Embroidery)/.test(P.Method || '')) {
              try { files.push(['_Proof image', new File([pr.blob], pr.name, { type: 'image/jpeg' })]); proofDone = true; } catch (e) {}
            }
            if (files.length) withFile.push({ it: it, files: files }); else rest.push(it);
          });
          if (pr) window.__bmnProof = null;
          if (withFile.length) return sendWithFiles(url, init, withFile, rest);
        }
      }
    } catch (e) {}
    return nativeFetch.apply(this, arguments);
  };
  function sendWithFiles(url, init, withFile, rest) {
    var added = [], chain = Promise.resolve();
    var multipartUrl = url.replace(/\/cart\/add(\.js)?/, '/cart/add.js');
    withFile.forEach(function (w) {
      chain = chain.then(function () {
        var fd = new FormData();
        fd.append('id', w.it.id); fd.append('quantity', w.it.quantity || 1);
        Object.keys(w.it.properties || {}).forEach(function (k) { fd.append('properties[' + k + ']', w.it.properties[k]); });
        w.files.forEach(function (f) { fd.append('properties[' + f[0] + ']', f[1], f[1].name); });
        return nativeFetch(multipartUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json().then(function (d) { if (r.ok) added.push(d); else rest.push(w.it); }); })
          .catch(function () { rest.push(w.it); });
      });
    });
    return chain.then(function () {
      if (!rest.length) {
        return new Response(JSON.stringify({ items: added }), { status: 200, headers: { 'Content-Type': 'application/json' } });
      }
      var init2 = {}; Object.keys(init).forEach(function (k) { init2[k] = init[k]; });
      init2.body = JSON.stringify({ items: rest });
      return nativeFetch(url, init2).then(function (r) {
        if (!r.ok || !added.length) return r;
        return r.json().then(function (d) {
          var items = (d.items || []).concat(added);
          return new Response(JSON.stringify({ items: items }), { status: 200, headers: { 'Content-Type': 'application/json' } });
        });
      });
    });
  }

  /* ---------- wiring ---------- */
  function refreshAll() {
    renderFab(); renderBanner(); scanCards();
    if (pdpReady && pdpRoot() && active()) autoStart();
    prefillBundle();
    try { document.dispatchEvent(new CustomEvent('bmn:sitelogo', { detail: active() ? getLogo() : null })); } catch (e) {}
  }
  /* Small public API for other page sections (assets/bmn-live-mockup.js). */
  CFG.get = function () { return active() ? getLogo() : null; };
  CFG.pick = function () { pick(); };
  // Designer plus (27 Oct 2026): save a logo found on the customer's website, then put it on every position waiting for one.
  CFG.saveFile = function (file) { return saveFromFile(file); };
  CFG.raw = function () { return getLogo(); };
  // One logo path (31 Oct 2026): the product page upload zone attaches non-image files (PDF, AI, EPS) to a position.
  CFG.attach = function (id, file) { if (id && file) attach[id] = file; };
  // Remove button on the product page (1 Nov 2026): forget the logo everywhere and drop the files waiting to attach.
  CFG.clear = function () { Object.keys(attach).forEach(function (k) { delete attach[k]; }); Object.keys(own).forEach(function (k) { delete own[k]; }); clearLogo(); };
  CFG.applyAll = function () {
    var root = pdpRoot(); if (!root || !active()) return;
    var on = root.querySelectorAll('.bmn-epdp__pos.is-on');
    if (!on.length) { autoDone = false; autoStart(); return; }
    Array.prototype.forEach.call(on, function (b) {
      var id = b.getAttribute('data-id'), sel = root.querySelector('select.bmn-epdp__source[data-pos="' + id + '"]');
      if (!sel || own[id]) return;
      if (sel.value === 'upload') { sel.value = 'later'; }
      applyToPos(id);
    });
    prefillBundleForce();
  };
  window.BMNSiteLogo = CFG;
  var mo, t;
  function boot() {
    refreshAll(); initPdp(); initBundle();
    mo = new MutationObserver(function (ms) {
      var hit = ms.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('.card-wrapper, #product-grid, .product-grid') || (n.querySelector && n.querySelector('.card-wrapper'))); }); });
      if (!hit) return; clearTimeout(t); t = setTimeout(function () { renderBanner(); scanCards(); }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === KEY_HIDE) { logoImgP = null; refreshAll(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
